"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const index_1 = require("../index");
const BooleanOperatorValueSelector = ({ device, value, onSelect, selectorAnimationDirection, }) => (React.createElement("div", { style: {
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        top: 56,
        left: 0,
        zIndex: 3,
        width: device === 'Mobile' ? '100%' : 384,
        height: device === 'Mobile' ? '100%' : 378,
        background: index_1.white,
        animation: `${selectorAnimationDirection} 150ms ease-in-out`,
    } },
    React.createElement(index_1.SelectableList, { device: device },
        React.createElement("div", { key: 0, style: {
                alignItems: 'center',
                display: 'flex',
                height: device === 'Mobile' ? 72 : 56,
                justifyContent: 'space-between',
                width: '100%',
            }, onClick: () => {
                onSelect(true);
            } },
            React.createElement(index_1.Text, { text: "is true", size: device === 'Mobile' ? 'large' : 'medium' }),
            React.createElement(index_1.RadioButton, { selected: value === true, style: {
                    outerStyle: {
                        height: 18,
                        width: 18,
                    },
                } })),
        React.createElement("div", { key: 1, style: {
                alignItems: 'center',
                display: 'flex',
                height: device === 'Mobile' ? 72 : 56,
                justifyContent: 'space-between',
                width: '100%',
            }, onClick: () => {
                onSelect(false);
            } },
            React.createElement(index_1.Text, { text: "is false", size: device === 'Mobile' ? 'large' : 'medium' }),
            React.createElement(index_1.RadioButton, { selected: value === false, style: {
                    outerStyle: {
                        height: 18,
                        width: 18,
                    },
                } })))));
exports.default = BooleanOperatorValueSelector;
